import React from 'react';
import { useStore, useStoreMap } from 'effector-react';
import { SceneType } from '@types';
import { $GateRotateEditMode } from '@stores/autoRotateStores';
import { $loadedScene } from '@stores/loadedStore';

export function RotateTip() {
  const isEditing = useStore($GateRotateEditMode.state);
  const hasOne = useStoreMap({
    store: $loadedScene,
    keys: [],
    fn: (scene) => !!scene?.config?.autoRotate?.tourData?.length,
  });
  const isMatrix = useStoreMap({
    store: $loadedScene,
    keys: [],
    fn: (scene) => scene?.type === SceneType.matrix,
  });
  if (!isEditing) return null;
  const name = isMatrix ? '矩阵' : '全景';
  return (
    <div className="absolute top-20 rounded bg-orange p-10 text-center">
      {hasOne ? (
        `双击${name}中的任意位置，可添加新节点`
      ) : (
        <>
          <p>已自动设置初始视角为起始节点</p>
          <p>{`双击${name}中的任意位置，可添加新节点`}</p>
        </>
      )}
    </div>
  );
}
